import type { BaseStoredNote } from "../types";

/** Display eligibility only. Spending must still require a validated leaf index. */
export function hasDisplayBalance(stored: BaseStoredNote): boolean {
  return (
    !stored.spent &&
    ((Number.isInteger(stored.note.leafIndex) && stored.note.leafIndex >= 0) ||
      stored.cachedConfirmedBalance === true)
  );
}

/** Call only on the authenticated, wallet/pool-scoped encrypted local cache. */
export function asDisplayOnlyCachedNotes(
  notes: BaseStoredNote[],
): BaseStoredNote[] {
  return notes
    .filter(
      (stored) =>
        stored?.note &&
        !stored.spent &&
        typeof stored.note.value === "bigint" &&
        stored.note.value >= 0n &&
        typeof stored.note.commitment === "string",
    )
    .map((stored) => ({
      ...stored,
      // Preserve the last confirmed display across reloads, including a reload
      // before revalidation finishes. Never promote an unconfirmed inbox note.
      cachedConfirmedBalance: hasDisplayBalance(stored),
      note: { ...stored.note, leafIndex: -1 },
    }));
}
